import React, { Suspense } from 'react';

import { Box, CircularProgress } from '@mui/material';

// Dynamically import templates
const Template1 = React.lazy(() => import("./Template1"));
const Template2 = React.lazy(() => import("./Template2"));
const Template3 = React.lazy(() => import("./Template3"));
const Template4 = React.lazy(() => import("./Template4"));
const Template5 = React.lazy(() => import("./Template5"));
const Template6 = React.lazy(() => import("./Template6"));
const Template7 = React.lazy(() => import("./Template7"));
const Template8 = React.lazy(() => import("./Template8"));
const Template9 = React.lazy(() => import("./Template9"));
// const Template10 = React.lazy(() => import("./Template10"));
const Template11 = React.lazy(() => import("./Template11"));
const Template12 = React.lazy(() => import("./Template12"));
const Template13 = React.lazy(() => import("./Template13"));
const Template14 = React.lazy(() => import("./Template14"));

const LoadingSpinner = () => (
  <Box width='200px' height='200px' className='center'>
    <CircularProgress
      size={24}
      sx={{
        display: "block",
        margin: "auto",
        color: "#1B9CCA",
      }}
    />
  </Box>
);

export const templates_data = [
  {
    id: "template1",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template1 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template2",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template2 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template3",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template3 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template4",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template4 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template5",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template5 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template6",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template6 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template7",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template7 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template8",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template8 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template9",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template9 {...props} />
      </Suspense>
    ),
  },
  // {
  //   id: "template10",
  //   renderTemplate: (props) => (
  //     <Suspense fallback={<LoadingSpinner />}>
  //       <Template10 {...props} />
  //     </Suspense>
  //   ),
  // },
  {
    id: "template11",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template11 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template12",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template12 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template13",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template13 {...props} />
      </Suspense>
    ),
  },
  {
    id: "template14",
    renderTemplate: (props) => (
      <Suspense fallback={<LoadingSpinner />}>
        <Template14 {...props} />
      </Suspense>
    ),
  },
];